import { promiseState } from "../../helper"
import { account } from "../actions/types"

const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},
	detail: {
		UserDetail: {},
	},
}

const accountReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(account.GET_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(account.GET_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(account.GET_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(account.GET_DETAIL_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(account.GET_DETAIL_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(account.GET_DETAIL_ACCOUNT): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		default:
			return state
	}
}

export default accountReducer
